export const MAP_LOADED = '@@map/MAP_LOADED';

export function mapLoaded() {
  return {
    type: MAP_LOADED
  };
}
